import { useEffect } from 'react';
import { careersStyles } from './styles';
import Layout from '../../components/Layout';
import Carousel from './Carousel';
import BackToTop from '../../components/BackToTop';
import Value from './Cards/Value';
import Benefit from './Cards/Benefit';
import MediaElement from './MediaElement';
import TopWaveImage from './images/top-wave.png';
import VideoPreview from './images/video-preview@2x.jpg';
import GreenHouseIFrame from '../../components/GreenHouseIFrame';
import greenHouse from '../../utils/greenHouse';

import './styles.css';

const assertBaseUrl = process.env.REACT_APP_ASSETS_BASE_URL;
const source = {
  src: `${assertBaseUrl}/videos/recruiting_video_fffcorp_winter18_mkvfinal_lb_1_1_1_2.mp4`,
  type: 'video/mp4',
};
const styles = careersStyles(assertBaseUrl);

const REGEX_JOB_POST = /jobpost/gi;
const REGEX_OPEN_POSITIONS = /open_positions/gi;

const Careers = () => {
  useEffect(() => {
    const currentUrl = window.location.href;
    const isAJobPosition = currentUrl.match(REGEX_JOB_POST);
    const hasOpenPositionsTagAlready = currentUrl.match(REGEX_OPEN_POSITIONS);
    if (isAJobPosition && !hasOpenPositionsTagAlready) {
      window.location.assign(`${window.location.href}#open_positions`);
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');

            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '50px 0px',
        threshold: 0.1,
      },
    );

    document
      .querySelectorAll(
        '.reveal1, .reveal2, .reveal3, .reveal4, .reveal5, .reveal6, .reveal7, .reveal8, .shape1, .shape3, .shape4, .shape5',
      )
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <Layout meta={greenHouse.meta} pageTitle="Careers - FabFitFun">
      <div id="content" className="siteContent">
        <div className="header-banner" />
        <div className="row-full">
          <article className="page type-page status-publish hentry">
            <div className="careers">
              <section className="hero" style={styles.hero}>
                <div className="hero__container hero__container--contentleft hero__container--contentbottom">
                  <div className="hero__content">
                    <h1 className="hero__title">
                      <span className="hero__title--sub">Join The FabFitFun Team</span>
                      You Bring the Fab, We Bring the Fun
                    </h1>
                    <p className="hero__subtext">
                      At FabFitFun, you’ll work with the friendliest, smartest, and most interesting
                      people you could hope for.
                    </p>
                    <div className="cta__container">
                      <a href="#testimonial" className="cta__btn cta__btn--white">
                        Watch Video
                      </a>
                      <a href="#open_positions" className="cta__btn cta__btn--primary">
                        See Open Positions
                      </a>
                    </div>
                  </div>
                </div>
                <div className="hero__wave">
                  <svg
                    id="wave"
                    width="100%"
                    viewBox="0 0 1440 121"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <g transform="translate(0.000000, -485.000000)" fill="#FFFFFF">
                        <path
                          d="M0,539 C74.6666667,508.333333 172.666667,504.333333 294,527 C476,561 539,568 708,561 C877,554 988,485 1157,485 C1269.66667,485 1364,503 1440,539 L1440,606 L0,606 L0,539 Z"
                          id="wave"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              </section>
              <section id="mission" className="mission reveal1">
                <div className="mission__copy">
                  <div className="c-shape-circle shape1" />
                  <h2>
                    <span className="title--sub">Our Mission</span>
                    Delivering Happiness and Well Being to Everyone, Everywhere
                  </h2>
                </div>
                <div className="mission__image">
                  <img
                    src={`${assertBaseUrl}/images/mission-statement.jpg`}
                    alt="Mission Statement"
                  />
                </div>
              </section>
              <section id="ourstory" className="ourstory reveal2">
                <div className="ourstory__container">
                  <div className="ourstory__copy c-shape-circle">
                    <h2>
                      <span className="title--sub">Our Story</span>
                      The FabFitFun History
                    </h2>
                    <p>
                      Founded in 2010 by Co-CEOs Daniel and Michael Broukhim and Editor-in-Chief
                      Katie Echevarria Rosen Kitchens, FabFitFun is a lifestyle membership that is
                      best known for its flagship product, the FabFitFun Box. The FabFitFun box
                      includes a selection of full-size products across beauty, fashion, fitness,
                      wellness, home, and tech – delivered each season. In addition to the Box,
                      FabFitFun members receive access to year-round perks including FabFitFunTV, a
                      streaming video service that offers on-demand wellness content, the FabFitFun
                      online Community, members-only shopping experiences, and so much more.
                    </p>
                  </div>
                </div>
                <div className="ourstory__image">
                  <img src={`${assertBaseUrl}/images/our-story.jpg`} alt="Our Story" />
                </div>
              </section>
              <section id="discover-yourself" className="discover-yourself reveal3">
                <div className="discover-yourself__copy">
                  <h2>
                    <span className="title--sub">Discover Yourself</span>
                    Find Your Fit
                  </h2>
                  <p>
                    <span className="title--sub">COMMITMENT TO DIVERSITY</span>
                    We are passionate about fostering an inclusive company culture and embracing the
                    diverse backgrounds and experiences that make us who we are. We know that hiring
                    and promoting individuals with multi-faceted backgrounds is essential to
                    building a successful, innovative, and long-lasting business.
                  </p>
                  <p>
                    <span className="title--sub">LEARNING &amp; ORGANIZATIONAL DEVELOPMENT</span>
                    The L&OD team strives to create a connected and fun learning community together;
                    to build a place where people and teams from diverse backgrounds feel safe and
                    inspired to experiment, collaborate and grow to be their best FAB self through
                    discovery. To achieve our vision, our work spans Learning & Development
                    (orientation, onboarding, internal & external learning opportunities),
                    Leadership Development (manager essentials program, executive coaching), Talent
                    Management (performance development, goal setting, feedback essentials), and OD
                    & Culture (championing FFF values, employee engagement, and organizational
                    design and development).
                  </p>
                </div>
                <div className="discover-yourself__image">
                  <img
                    src={`${assertBaseUrl}/images/discover-yourself.jpg`}
                    alt="Discover yourself"
                  />
                  <div className="c-shape-circle shape3" />
                </div>
              </section>
              <section id="testimonial" className="testimonial reveal4">
                <div className="testimonial__container">
                  <h6 className="title--sub">FABFITFUN EMPLOYEE TESTIMONIAL</h6>
                  <div className="testimonial__video">
                    <div
                      className="content"
                      style={{
                        width: '90vw',
                        maxWidth: '996px',
                        maxHeight: '560px',
                        margin: '0 auto',
                      }}
                    >
                      <MediaElement
                        id="Testimonial"
                        preload="auto"
                        controls
                        width="100%"
                        height="100%"
                        poster={VideoPreview}
                        source={source}
                        options={JSON.stringify({})}
                      />
                    </div>
                    <div className="c-shape-circle shape4" />
                    <div className="c-shape-square shape5" />
                  </div>
                </div>
                <a href="#open_positions" className="cta__btn">
                  View Open Positions
                </a>
              </section>
            </div>
            <hr className="hr1" />
            <section className="values reveal5">
              <h2>Our Values</h2>
              <div className="cards__container">
                <Value
                  title="We Act Like Owners"
                  description="Think of this as your company and hold yourself accountable for its growth. No job is too big or too small."
                  icon="fa-user"
                />
                <Value
                  title="We Elevate And Evolve"
                  description="Look for growth opportunities in every interaction. Push yourself by taking smart risks and embracing uncertainty."
                  icon="fa-magic"
                />
                <Value
                  title="We Play To Win"
                  description="It takes the collective efforts of the team to win the game. Look for ways to create impact to every project, meeting, and task you’re given."
                  icon="fa-trophy"
                />
                <Value
                  title="We Put Members First"
                  description="Across all departments, we always keep the members’ best interests at heart. Make short-term sacrifices for a lifetime of loyalty."
                  icon="fa-crown"
                />
                <Value
                  title="We Make FFF A Great Place To Work"
                  description="Celebrate your team’s wins. Create a safe space for diverse opinions and expression. Treat everyone with respect. We’re on this ride together!"
                  icon="fa-handshake"
                />
              </div>
            </section>
            <hr className="hr1" />
            <section className="self-explanatory reveal6">
              <div className="self-explanatory__copy">
                <h2>
                  <span className="title--sub">IT’S SELF EXPLANATORY</span> We’re Fab, Fit, &amp;
                  Fun
                </h2>
              </div>
              <div className="slickslide__container">
                <Carousel />
              </div>
            </section>
            <hr className="hr1" />
            <section className="benefits reveal7" style={styles.benefits}>
              <div className="top__wave">
                <img src={TopWaveImage} className="top-wave" alt="wave" />
              </div>
              <div className="benefits__container">
                <div className="benefits__image" style={styles.benefits__image}>
                  <img src={`${assertBaseUrl}/images/fff-collective.png`} alt="Benefits" />
                </div>
                <div className="benefit__wrapper">
                  <div className="benefits__content">
                    <h3 className="benefits__title">FabFitFun Benefits</h3>
                    <Benefit
                      title="Opportunity of a Lifetime"
                      description="Help shape the future of a rapidly growing organization and industry."
                      icon="fa-key"
                    />
                    <Benefit
                      title="As We Grow, You Do Too"
                      description="We prioritize career growth for all employees with the ability to work within a highly collaborative, passionate, and development-focused environment."
                      icon="fa-tree-alt"
                    />
                    <Benefit
                      title="All of the Benefits"
                      description="Medical, Dental, Vision, Disability & life insurance, and 401k!"
                      icon="fa-piggy-bank"
                    />
                    <Benefit
                      title="Paid Time Off"
                      description="We offer a flexible PTO policy, we trust our employees to manage their time!"
                      icon="fa-umbrella-beach"
                    />
                    <Benefit
                      title="Employee Perks"
                      description="Tons of perks such as a quarterly credit to our Add-ons store, cell phone reimbursement, paid parking, and a fully stocked kitchen with snacks and drinks!"
                      icon="fa-stars"
                    />
                    <Benefit
                      title="Dog Friendly Office"
                      description="We encourage you to bring your furry friends to work!"
                      icon="fa-paw"
                    />
                    <Benefit
                      title="We’re All Members"
                      description="Being part of our family means a free FFF subscription so that you can have the full experience of our membership"
                      icon="fa-crown"
                    />
                  </div>
                </div>
              </div>
              <div className="bottom__wave">
                <svg
                  width="100%"
                  viewBox="0 0 1440 85"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <title>bottom-wave</title>
                  <g id="bottom-wave" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                    <g
                      id="careers-desktop"
                      transform="translate(0.000000, -5694.000000)"
                      fill="#FFFFFF"
                      fillRule="nonzero"
                    >
                      <g id="Group-7" transform="translate(0.000000, 4955.000000)">
                        <g id="Bitmap" transform="translate(0.000000, 0.000000)">
                          <path
                            d="M0,739 L1440,739 L1440,830 C1360,777.333333 1222.96615,751 1028.89844,751 C737.796875,751 553.789062,836 356.195312,836 C224.466146,836 105.734375,820.666667 0,790 L0,739 Z"
                            id="bottom-wave"
                            transform="translate(720.000000, 787.500000) scale(1, -1) translate(-720.000000, -787.500000) "
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </section>
            <hr className="hr1" />
            <section className="openposition reveal8" id="open_positions">
              <div className="openposition_content">
                <h2>Open Positions</h2>
                <p>
                  Want to be a part of the FabFitFun team and think you have what it takes? We would
                  love to meet you. Check out our open jobs.
                </p>
              </div>
              <div className="openposition__list">
                <GreenHouseIFrame page={greenHouse.pages.CAREERS} />
              </div>
            </section>
            <section className="disclaimer">
              <p>
                FabFitFun (FFF) does not accept unsolicited agency resumes. Please do not send or
                apply unsolicited resumes to our job openings, FFF employees or any other FFF brand
                or company location. FFF is not responsible for any fees related to unsolicited
                resumes.
              </p>
              <p>
                This{' '}
                <a
                  href="https://www.cigna.com/legal/compliance/machine-readable-files"
                  target="_blank"
                  rel="noreferrer"
                >
                  link
                </a>{' '}
                leads to the machine-readable files that are made available in response to the
                federal Transparency in Coverage Rule and includes negotiated service rates and
                out-of-network allowed amounts between health plans and healthcare providers. The
                machine readable files are formatted to allow researchers, regulators, and
                application developers to more easily access and analyze data.
              </p>
            </section>
          </article>
        </div>
        <BackToTop />
      </div>
    </Layout>
  );
};
export default Careers;
